// extracted by mini-css-extract-plugin
export default {"experience":"About_experience__yMFxK","header":"About_header__wL9TZ","imageContainer":"About_imageContainer__yp9Mw","aboutText":"About_aboutText__8T7jZ"};